import { range } from 'lodash';

// makePageIndices will return an array at most maxPagesToShow
// in length. 1-based indexing. The numbers will range between [1, totalPages].
export const makePageIndices = ({
  totalPages,
  maxPagesToShow,
  currentPage,
}) => {
  const diff = Math.floor(maxPagesToShow / 2);
  let minPage = currentPage - diff;
  let maxPage = currentPage + diff;
  if (minPage < 1) {
    maxPage += (1 - minPage);
    minPage = 1;
  } else if (maxPage > totalPages + 1) {
    minPage -= (maxPage - totalPages - 1);
    maxPage = totalPages + 1;
  }
  minPage = Math.max(1, minPage);
  maxPage = Math.min(totalPages + 1, maxPage);
  return range(minPage, maxPage);
};
